import { Box, Card, Group, Text } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '@/components/usePageTitle';
import { StallsScreen } from '@/features/ops/StallsScreen';
import { brand } from '@/theme/theme';

export const Route = createFileRoute('/_staff/staff/ops')({ component: StaffOpsPage });

function StaffOpsPage() {
  const { t } = useTranslation();
  const { t: to } = useTranslation('ops');
  usePageTitle(t('staff.operations'));

  return (
    <Card p={0}>
      <Group px={16} py={10} bg={brand.dark} gap={8}>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke={brand.yellow} strokeWidth="1.5" aria-hidden="true">
          <path d="M1 8l2.5-4 2 6 2-8 2.5 6H13" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <Text fz={12} fw={700} tt="uppercase" c={brand.onDark} style={{ letterSpacing: '0.08em' }}>
          {to('stalls.title')}
        </Text>
      </Group>
      <Box p="lg">
        <StallsScreen />
      </Box>
    </Card>
  );
}
